export default __webpack_public_path__ + "static/media/ic_liquidity.0b0aa7d0.svg";